import Icon from '../Icon';

const Demo6Features4 = () => {
    return (
        <section id="features-4" className="pb-60 features-section division">
            <div className="container">
                <div className="fbox-4-wrapper">
                    <div className="row row-cols-1 row-cols-md-2">
                        <div className="col">
                            <div className="fbox-4 pc-25 mb-40 wow fadeInUp">
                                <div className="fbox-ico">
                                    <div className="fbox-ico-center ico-65">
                                        <Icon symbol="🖥️" decorative className="feature-icon" />
                                    </div>
                                </div>
                                <div className="fbox-txt">
                                    <h5 className="h5-md">Translation Memory</h5>
                                    <p className="p-lg">
                                        Never translate the same sentence twice. Our engine remembers past translations to lower costs and ensure consistency.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="fbox-4 pc-25 mb-40 wow fadeInUp">
                                <div className="fbox-ico">
                                    <div className="fbox-ico-center ico-65">
                                        <Icon symbol="⚙️" decorative className="feature-icon" />
                                    </div>
                                </div>
                                <div className="fbox-txt">
                                    <h5 className="h5-md">Glossary Management</h5>
                                    <p className="p-lg">
                                        Maintain your brand voice. Define your key terms and ensure they are translated correctly across every project.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="fbox-4 pc-25 mb-40 wow fadeInUp">
                                <div className="fbox-ico">
                                    <div className="fbox-ico-center ico-65">
                                        <Icon symbol="🗂️" decorative className="feature-icon" />
                                    </div>
                                </div>
                                <div className="fbox-txt">
                                    <h5 className="h5-md">Smart Quality Checks</h5>
                                    <p className="p-lg">
                                        Catch errors before they go live. Automated checks for numbers, formatting, and untranslated segments.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="fbox-4 pc-25 mb-40 wow fadeInUp">
                                <div className="fbox-ico">
                                    <div className="fbox-ico-center ico-65">
                                        <Icon symbol="🎞️" decorative className="feature-icon" />
                                    </div>
                                </div>
                                <div className="fbox-txt">
                                    <h5 className="h5-md">Format Preservation</h5>
                                    <p className="p-lg">
                                        Upload complex documents and get them back with the exact same layout. We handle the formatting so you don't have to.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="fbox-4 pc-25 mb-40 wow fadeInUp">
                                <div className="fbox-ico">
                                    <div className="fbox-ico-center ico-65">
                                        <Icon symbol="🔗" decorative className="feature-icon" />
                                    </div>
                                </div>
                                <div className="fbox-txt">
                                    <h5 className="h5-md">Team Roles & Access</h5>
                                    <p className="p-lg">
                                        Control who can see, edit, and export. Assign roles to project managers, translators, and reviewers.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="fbox-4 pc-25 mb-40 wow fadeInUp">
                                <div className="fbox-ico">
                                    <div className="fbox-ico-center ico-65">
                                        <Icon symbol="➕" decorative className="feature-icon" />
                                    </div>
                                </div>
                                <div className="fbox-txt">
                                    <h5 className="h5-md">App Integration</h5>
                                    <p className="p-lg">
                                        Connect your favorite tools directly to Rush Studio and sync translations back with a single click.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Demo6Features4;
